var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cloudsponge)?_c('a',{class:_vm.buttonClass,on:{"click":function($event){return _vm.startImport(_vm.source)}}},[_c('img',{attrs:{"src":`/assets/icons/${_vm.icon}-icon.png`}}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }